import {
  API_CRM_AUTO_SENTIMENT
} from 'constants/ApiUrls'
import { METHOD_POST, METHOD_PUT } from 'constants/Methods'
import { createApi } from 'utils/index'

export const getSettings = () => createApi(API_CRM_AUTO_SENTIMENT)
export const createSettings = (data) => createApi(API_CRM_AUTO_SENTIMENT, METHOD_POST, data)
export const updateSettings = (data) => createApi(API_CRM_AUTO_SENTIMENT, METHOD_PUT, data)
